import React, { PureComponent } from 'react';
import ReactLink from '@client/components/reactLink/ReactLink';
import { strings } from '@client/localization/Localization';
import { ROUTES } from '@client/pages/routes';
import { COLORS } from '@client/shared/js/Colors';
import indicators from '@client/shared/js/indicators';
import themeStyles from '@client/shared/styles/theme/theme-styles.scss';
import styles from './contactBoxes.scss';

class ContactBoxes extends PureComponent {
  render() {
    return (
      <div className={styles.contactBoxesSection}>
        <div className={styles.boxesContainer}>
          <div
            className={styles.box}
            style={{ backgroundColor: `${COLORS.colorBrandPurple}` }}
          >
            <div className={styles.textBox}>
              <div
                className={`${themeStyles.contactTitle} ${styles.contactTitle}`}
              >
                {strings.alien}
              </div>
              <div className={`${themeStyles.subText} ${styles.subText}`}>
                {strings.whatsYourStory}
              </div>
              <div className={`${themeStyles.subText} ${styles.subText}`}>
                <div className={styles.socialIconWrapper}>
                  <i className={`icomoon icon-mail ${styles.socialIcon}`} />
                </div>
                <a href={`mailto:${strings.emailIdea}`}>
                  <div className={styles.textWrapper}>{strings.emailIdea}</div>
                </a>
              </div>
            </div>
          </div>
          <div
            className={styles.box}
            style={{ backgroundColor: `${COLORS.colorBrandGreen}` }}
          >
            <div className={styles.textBox}>
              <div
                className={`${themeStyles.contactTitle} ${styles.contactTitle}`}
              >
                {strings.workWithUs}
              </div>
              <div className={`${themeStyles.subText} ${styles.subText}`}>
                {strings.workWithUsLeadText}
              </div>
              <div className={`${themeStyles.subText} ${styles.subText}`}>
                <div className={styles.socialIconWrapper}>
                  <i className={`icomoon icon-mail ${styles.socialIcon}`} />
                </div>
                <a href={`mailto:${strings.emailWork}`}>
                  <div className={styles.textWrapper}>{strings.emailWork}</div>
                </a>
              </div>
            </div>
          </div>
          <div
            className={styles.box}
            style={{ backgroundColor: `${COLORS.colorBrandBlue}` }}
          >
            <div className={styles.textBox}>
              <div
                className={`${themeStyles.contactTitle} ${styles.contactTitle}`}
              >
                {strings.collaborateWithUs}
              </div>
              <ReactLink to={ROUTES.collaborate}>
                <button
                  type="button"
                  className={`${themeStyles.btnPrimary} ${styles.button}`}
                >
                  <img src={indicators.arrow_black} />
                  {strings.findOutMore}
                </button>
              </ReactLink>
              <div className={`${themeStyles.subText} ${styles.subText}`}>
                <div className={styles.socialIconWrapper}>
                  <i className={`icomoon icon-mail ${styles.socialIcon}`} />
                </div>
                <a href={`mailto:${strings.emailCollaborate}`}>
                  <div className={styles.textWrapper}>
                    {strings.emailCollaborate}
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ContactBoxes;
